import { type DeepReadonly } from "./utils/types";

import { type RouteConfigEntry } from "@react-router/dev/routes";

// TODO: Consider checking for topas2 routes and redirecting to / for topasXL users
export const TOPAS_XL_SELF_DEFINED_ROUTES = [
  {
    file: "./routes/_authenticated.tsx",
    id: "topasXlAuthenticated",
    children: [
      {
        file: "./features/topasXl/pages/TopasXlLayout.tsx",
        id: "topasXlLayout",
        children: [
          {
            file: "./features/topasXl/pages/TopasXlIndex.tsx",
            id: "topasXlIndex",
            index: true,
          },
          {
            file: "./features/topasXl/pages/train-info/TrainInfoLayout.tsx",
            id: "trainInfoLayout",
            path: "train-info",
            children: [
              {
                file: "./features/topasXl/pages/train-info/TrainInfoRollingStock.tsx",
                id: "trainInfoIndex",
                index: true,
              },
              {
                file: "./features/topasXl/pages/train-info/TrainInfoRollingStock.tsx",
                id: "trainInfoRollingStock",
                path: "rollingstock",
              },
              {
                file: "./features/topasXl/pages/train-info/TrainInfoApc.tsx",
                id: "trainInfoApc",
                path: "apc",
              },
              {
                file: "./features/topasXl/pages/train-info/TrainInfoTraffic.tsx",
                id: "trainInfoTraffic",
                path: "traffic",
              },
              {
                file: "./features/topasXl/pages/train-info/TrainInfoRealtime.tsx",
                id: "trainInfoRealtime",
                path: "realtime",
              },
              {
                file: "./features/topasXl/pages/train-info/TrainInfoEvents.tsx",
                id: "trainInfoEvents",
                path: "events",
              },
            ],
          },
          {
            file: "./features/topasXl/pages/stations/StationsLayout.tsx",
            id: "stationsLayout",
            path: "stations",
            children: [
              {
                file: "./features/topasXl/pages/stations/StationsIndex.tsx",
                id: "stationsIndex",
                index: true,
              },
              {
                file: "./features/topasXl/pages/stations/StationsDepartures.tsx",
                id: "stationsDepartures",
                path: "departures",
              },
              {
                file: "./features/topasXl/pages/stations/StationsArrivals.tsx",
                id: "stationsArrivals",
                path: "arrivals",
              },
              {
                file: "./features/topasXl/pages/stations/StationsActivities.tsx",
                id: "stationActivities",
                path: "activities",
              },
            ],
          },
          {
            file: "./features/topasXl/pages/rolling-stock/RollingStockLayout.tsx",
            id: "rollingStockLayout",
            path: "rolling-stock",
            children: [
              {
                file: "./features/topasXl/pages/rolling-stock/RollingStockIndex.tsx",
                id: "rollingStockIndex",
                index: true,
              },
              {
                file: "./features/topasXl/pages/rolling-stock/RollingStockMap.tsx",
                id: "rollingStockMap",
                path: "map",
              },
              {
                file: "./features/topasXl/pages/rolling-stock/RollingStockRosters.tsx",
                id: "rollingStockRosters",
                path: "rosters",
              },
              {
                file: "./features/topasXl/pages/rolling-stock/RollingStockInformation.tsx",
                id: "rollingStockInformation",
                path: "information",
              },
            ],
          },
          {
            file: "./features/topasXl/pages/events/Events.tsx",
            path: "events",
          },
        ],
      },
    ],
  },
] as const satisfies DeepReadonly<RouteConfigEntry[]>;

// TODO: Consider defining a catchall for desktop routes and redirect to / for non-topasXL users
export const TOPAS_2_SELF_DEFINED_ROUTES = [] as const satisfies DeepReadonly<
  RouteConfigEntry[]
>;
